import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { InventoryLayout } from "@/screens/Inventory/components"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const Route = createFileRoute("/app/inventory/_layout")({
  loader: () => useUnitOfMeasurementsStore.getState().getUnits(),
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.INVENTORY_VIEW]}>
      <InventoryLayout />
    </PermissionContentWrapper>
  ),
})
